export function isValidConfId(confId: unknown): confId is string {
    if (typeof confId !== "string") {
        return false
    }
    if (confId.length !== 11) {
        return false
    }
    return /^[A-Za-z0-9_-]+$/.test(confId)
}
